import money from '@/core/charts/components/money'
import tooltip from '@/core/charts/components/tooltip-standard'
import formatter from '@/core/charts/helper/formatter'
import chartColors from '@/core/charts/helper/chartColors'

export default {
  showLegend: false,
  showSmallLegend: true,
  chartOpts: getOptions(),

  chartData: (widget, data) => getChartData(widget, data),
  chartInfo: (widget, data) => getChartInfo(data, getVariableIndex(widget)),
  drillDown: (ctx, value, index) => executeDrillDown(ctx, value, index),
  drillDownReturn: (ctx) => reverseDrillDown(ctx),

  components: {
    labelValue: money,
    tooltip
  }
}

function getOptions() {
  let baseCustSet = {
    chartGroupValue: 'FromFilter:PaymentStatusMainFilter',
    containterStyle: '',
    hasDrillDown: true,
    recalculateGridMax: true,
    showTotal: true,
    multipleSeries: true,
    dynamicHeight: true,
    tooltip: {
      tooltipType: 'standard',
      width: '330px'
    }
  }
  let baseOpts = {
    customSettings: baseCustSet,
    stackBars: true,
    seriesBarDistance: 18,
    horizontalBars: true,
    targetLine: {
      value: 0,
      class: 'ct-target-line'
    },
    labelInterpolationFnc: function(value) { return value[0] },
    fullWidth: false,
    axisY: {
      position: 'start',
      labelOffset: { x: 2, y: 1 },
      scaleMinSpace: 15,
      showGrid: true,
      showLabel: true,
      offset: 140,
      labelInterpolationFnc: function(value) { return value } // return formatter.thousandsFormatter(value) }
    },
    chartPadding: { top: 2, right: 25, bottom: 5, left: 5 }
  }
  return baseOpts
}

function getChartInfo(dataIn, pos) {
  let result = []
  dataIn.forEach(elem => {
    let gdPos = result.findIndex(k => k[0] === elem[pos])
    if (gdPos === -1) result.push(elem[pos])
  })
  return result.map(k => k[0])
}

function getChartData(widget, data) {
  let labelsGrouped = []
  let totalSpend = 0
  let grInx = getVariableIndex(widget)
  data.forEach(elem => {
    let label = grInx === 5 ? elem[5] + (elem[6] ? ' (' + elem[6] + ')' : '') : elem[grInx]
    if (label !== '') {
      var gdPos = labelsGrouped.findIndex(k => k[0] === label)
      if (gdPos === -1) {
        labelsGrouped.push([label, 0, [0, 0, 0, 0]])
      }
      var labelPos = labelsGrouped.findIndex(k => k[0] === label)
      labelsGrouped[labelPos][1] += (elem[7] + elem[8] + elem[9] + elem[10])
      labelsGrouped[labelPos][2][0] += elem[7] || 0
      labelsGrouped[labelPos][2][1] += elem[8] || 0
      labelsGrouped[labelPos][2][2] += elem[9] || 0
      labelsGrouped[labelPos][2][3] += elem[10] || 0
    }
  })
  let sortedData = labelsGrouped.slice(0)
  sortedData.sort(function (a, b) { return a[1] - b[1] })
  let totals = sortedData.map(k => k[1])
  let maxValue = formatter.getArrayMaxValue(totals)
  let minValue = formatter.getArrayMinValue(totals)
  let seriesGrouped = sortedData.map(k => k[2])
  totals = sortedData.map(k => formatter.thousandsFormatter(k[1]))
  return {
    total: totalSpend.toFixed(2),
    labels: sortedData.map(k => k[0]),
    series: [
      {
        type: 'Bar',
        stackBars: true,
        maxValue: maxValue,
        minValue: minValue,
        ignoreForCharts: false,
        barSpace: 40,
        minHeight: 90,
        data: [
          {
            name: 'Balance',
            value: seriesGrouped.map(k => k[0].toFixed(2)),
            color: chartColors.blueLight,
            width: '25px',
            ignoreLabel: true
          },
          {
            name: 'Scheduled Payments - Funds Not Received',
            value: seriesGrouped.map(k => k[2].toFixed(2)),
            color: chartColors.green,
            width: '25px',
            ignoreLabel: true
          },
          {
            name: 'Scheduled Payments - Funds Received',
            value: seriesGrouped.map(k => k[1].toFixed(2)),
            color: chartColors.purple,
            width: '25px',
            ignoreLabel: true
          },
          {
            name: 'Received Payments',
            value: seriesGrouped.map(k => k[3].toFixed(2)),
            color: chartColors.yellowish,
            width: '25px',
            ignoreLabel: false,
            metadata: { barLabels: totals }
          }
        ]
      }
    ],
    tooltipData: {
      helpText: 'Click on the bar to show Invoice spend details.',
      metadata: tooltipMetadata,
      data: [
        sortedData.map(t => t[0]),
        seriesGrouped.map(k => k[0].toFixed(2)),
        seriesGrouped.map(k => k[2].toFixed(2)),
        seriesGrouped.map(k => k[1].toFixed(2)),
        seriesGrouped.map(k => k[3].toFixed(2)),
        sortedData.map(k => k[1])
      ]
    }
  }
}

function getChartDataDrilled(dataIn, pos) {
  if (dataIn.length === 0) return {labels: null, series: []}
  let display = pos === 5 ? 0 : 5
  let labelsGrouped = []
  dataIn.forEach(inv => {
    let label = inv[display]
    let pos = labelsGrouped.findIndex(k => k[0] === label)
    if (pos === -1) {
      labelsGrouped.push([label, 0, [0, 0, 0, 0], '', ''])
    }
    var labelPos = labelsGrouped.findIndex(k => k[0] === label)
    labelsGrouped[labelPos][1] += (inv[7] + inv[8] + inv[9] + inv[10])
    labelsGrouped[labelPos][2][0] += inv[7] || 0
    labelsGrouped[labelPos][2][1] += inv[8] || 0
    labelsGrouped[labelPos][2][2] += inv[9] || 0
    labelsGrouped[labelPos][2][3] += inv[10] || 0
    labelsGrouped[labelPos][3] = inv[1] + (inv[3] ? ' (' + inv[3] + ')' : '')
    labelsGrouped[labelPos][4] = display === 5 ? inv[0] : inv[5]
    labelsGrouped[labelPos][5] = 'Invoice Due Date: ' + inv[11]
  })
  let sortedData = labelsGrouped.slice(0)
  sortedData.sort(function (a, b) { return a[1] - b[1] })
  let totals = sortedData.map(k => k[1])
  let maxValue = formatter.getArrayMaxValue(totals)
  let minValue = formatter.getArrayMinValue(totals)
  let seriesGrouped = sortedData.map(k => k[2])
  totals = sortedData.map(k => formatter.thousandsFormatter(k[1]))
  return {
    total: 0,
    labels: sortedData.map(k => k[0]),
    series: [
      {
        type: 'Bar',
        stackBars: true,
        maxValue: maxValue,
        minValue: minValue,
        ignoreForCharts: false,
        barSpace: 36,
        minHeight: 90,
        data: [
          {
            name: 'Balance',
            value: seriesGrouped.map(k => k[0].toFixed(2)),
            color: chartColors.blueLight,
            width: '25px',
            ignoreLabel: true
          },
          {
            name: 'Scheduled Payments - Funds Not Received',
            value: seriesGrouped.map(k => k[2].toFixed(2)),
            color: chartColors.green,
            width: '25px',
            ignoreLabel: true
          },
          {
            name: 'Scheduled Payments - Funds Received',
            value: seriesGrouped.map(k => k[1].toFixed(2)),
            color: chartColors.purple,
            width: '25px',
            ignoreLabel: true
          },
          {
            name: 'Received Payments',
            value: seriesGrouped.map(k => k[3].toFixed(2)),
            color: chartColors.yellowish,
            width: '25px',
            ignoreLabel: false,
            metadata: { barLabels: totals }
          }
        ]
      }
    ],
    tooltipData: {
      metadata: tooltipMedatadaDrilled,
      data: [
        sortedData.map(t => t[0]),
        sortedData.map(t => t[3]),
        sortedData.map(t => t[4]),
        sortedData.map(t => t[5]),
        seriesGrouped.map(k => k[0].toFixed(2)),
        seriesGrouped.map(k => k[2].toFixed(2)),
        seriesGrouped.map(k => k[1].toFixed(2)),
        seriesGrouped.map(k => k[3].toFixed(2)),
        sortedData.map(k => k[1])
      ]
    }
  }
}

function executeDrillDown(ctx, value) {
  let selected = value
  let data = []
  ctx.rawData.forEach(el => {
    el[5] = el[5] + (el[6] ? ' (' + el[6] + ')' : '')
    el[6] = null
    data.push(el)
  })
  let filterIndex = getVariableIndex(ctx.widget)
  let fullData = data.filter(row => ~row.indexOf(selected))
  ctx.chartData = getChartDataDrilled(fullData, filterIndex)
  ctx.chartInfo = getChartInfo(fullData, 1)
  ctx.chartComponent.chartOpts.stackBars = true
  ctx.chartComponent.chartOpts.customSettings.hasDrillDown = false
  ctx.chartComponent.chartOpts.customSettings.tooltip = {
    width: '330px',
    topOffset: -10,
    leftOffset: 50
  }
  ctx.$emit('childRedraw')
}

function reverseDrillDown(ctx) {
  ctx.chartComponent.chartOpts = getOptions()
  ctx.$emit('childRedraw')
}

function getVariableValue(widget) {
  let variable = widget.variables.filter(function(s) {
    if (s.name === 'PaymentStatusMainFilter') return s.value[0]
    else return null
  })
  return variable[0].value[0]
}

function getVariableIndex(widget) {
  let variableVal = getVariableValue(widget)
  if (variableVal === 'Programs') return 1
  else if (variableVal === 'Supplier') return 5
  return 4 // for divisions
}

const tooltipMetadata = [
  {
    label: '',
    type: 'title',
    format: ''
  },
  {
    label: 'Balance',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Scheduled Payments - Funds Not Received',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Scheduled Payments - Funds Received',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Received Payments',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Total',
    type: 'secondary',
    format: 'currency'
  }
]

const tooltipMedatadaDrilled = [
  {
    label: '',
    type: 'title',
    format: ''
  },
  {
    label: 'Program',
    type: 'subtitle',
    format: ''
  },
  {
    label: '',
    type: 'subtitle',
    format: ''
  },
  {
    label: '',
    type: 'subtitle',
    format: ''
  },
  {
    label: 'Balance',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Scheduled Payments - Funds Not Received',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Scheduled Payments - Funds Received',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Received Payments',
    type: 'main',
    format: 'currency'
  },
  {
    label: 'Total',
    type: 'secondary',
    format: 'currency'
  }
]



// WEBPACK FOOTER //
// ./src/components/_modules/Dashboard/widgets/InvoicePaymentStatus/chart.js